import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_SIGNUP_QUERY_KEY = "bot-signup";

type BotSignupParams = {
  appPubKey: string;
  userId: string;
  referrer: string;
};

const postBotSignup = async (api: Api, params: BotSignupParams): Promise<any> =>
  api.post("signup", { json: params }).json();

const useBotSignupMutation = () =>
  useMutation({
    mutationFn: async (params: BotSignupParams) => postBotSignup(api, params),
    mutationKey: [BOT_SIGNUP_QUERY_KEY],
  });

export { useBotSignupMutation, BOT_SIGNUP_QUERY_KEY };
